// extracted by mini-css-extract-plugin
export var animations = "header-module--animations--RD8W-";
export var navAnimations = "header-module--navAnimations--32sn1";
export var navbarLocal = "header-module--navbar-local--2ng-k";
export var sitenav = "header-module--sitenav--3j-G1";
export var navrow = "header-module--navrow--1jiaB";
export var sitemenu = "header-module--sitemenu--1bav_";